import {
  reclaimActivationSurfaces,
  type ReclaimActivationSurface,
} from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const RECLAIM_ACTIVATION_SURFACE_PARAM = "surface";

export function parseReclaimActivationSurface(
  raw: string | null | undefined,
): ReclaimActivationSurface | undefined {
  return reclaimActivationSurfaces.find((surface) => surface === raw);
}

/**
 * The surface a merchant reached onboarding from, when the team record cannot
 * reveal it. Everything else about the commercial channel is derived server
 * side; only the in-dashboard Reclaim CTA knows something the team does not,
 * and it says so with `?surface=in_app_discovery`. Absent means the derived
 * channel decides, which is what a merchant arriving any other way should get.
 */
export function useReclaimActivationSurface():
  | ReclaimActivationSurface
  | undefined {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get(RECLAIM_ACTIVATION_SURFACE_PARAM);
  return useMemo(() => parseReclaimActivationSurface(raw), [raw]);
}

/** Appends the surface so it survives a round trip that leaves the app. */
export function withReclaimActivationSurface(
  path: string,
  surface: ReclaimActivationSurface | undefined,
): string {
  if (surface === undefined) {
    return path;
  }
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${RECLAIM_ACTIVATION_SURFACE_PARAM}=${encodeURIComponent(surface)}`;
}
